import type { RfxListTab } from "../../types/rfx-list.type";

/**
 * `tenders_quotes` only offers these five tabs (Contract Table row 1 —
 * `App\Services\RFx\RfxClientViewService::tendersQuotesTabMap()`). An
 * unrecognised tab key reaching row-rendering is a silent-empty-tab class
 * bug (a drift between this FE and the backend map) — fail loud instead.
 */
export const TENDERS_QUOTES_TABS: readonly RfxListTab[] = [
	"current",
	"evaluation",
	"awarded",
	"drafts",
	"archived",
] as const;

export const assertKnownTendersQuotesTab = (tab: RfxListTab): void => {
	if (!(TENDERS_QUOTES_TABS as readonly string[]).includes(tab)) {
		throw new Error(
			`Unrecognised tenders_quotes tab key "${tab}" — FE/BE tab-map drift.`
		);
	}
};

/**
 * Exhaustive per-tab empty-state copy. The `default` throw is the enum-mapping
 * guard: a sixth tab key added to the backend map without a matching FE case
 * here fails loudly instead of silently falling back to generic copy.
 */
export const getTendersQuotesEmptyStateCopy = (tab: RfxListTab): string => {
	switch (tab) {
		case "current":
			return "No current RFx yet. Create one to get started.";
		case "evaluation":
			return "No RFx are in evaluation.";
		case "awarded":
			return "No awarded RFx yet.";
		case "drafts":
			return "No draft RFx.";
		case "archived":
			return "No archived RFx.";
		default:
			throw new Error(
				`Unrecognised tenders_quotes tab key "${tab}" — FE/BE tab-map drift.`
			);
	}
};
